// Angular Material
//import 'hammerjs';

import { enableProdMode } from '@angular/core';

import { Config } from '@config/base';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { ServiceLocator } from '@summit/core';
import { colorConsole, debugBuild } from './app-debug';
import { appConfig } from './app/app-config';
import { environment } from './environments/environment';
import { initSentry } from './sentry-io';
if (debugBuild)
  console.log(
    `%c----> Starting Ebo Pro Client V${Config.version}  <----`,
    'color: black; background: #64dd17; font-size: 14px'
  );

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

if (debugBuild) colorConsole(`----> Base URL ${getBaseUrl()} <----`);
// const loadingElement = document.querySelector('.app-loading');
// const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: <any>[] }];
if (environment.production) {
  enableProdMode();
}
if (debugBuild) colorConsole('----> Init Sentry <----');
initSentry();
bootstrapApplication(AppComponent, appConfig)
  .then((_ref) => {
    if (debugBuild) colorConsole('----> App Bootstrapped <----');
    ServiceLocator.injector = _ref.injector;
    // loadingElement.classList.add('loaded');
    // setTimeout(() => loadingElement.remove(), 100);
    if (debugBuild) colorConsole('----> App Done Initial Load <----');
  })
  .catch((err) => {
    console.log('failed to load');
    console.warn(err);
  });
